/* ArtMindr — прави блоковете във футъра сгъваеми на телефон.
   Нищо не пипа над 750px. Ако скриптът не се зареди, футърът си остава както е. */
(function () {
  'use strict';
  var MQ = '(max-width: 749px)';

  function init() {
    var footer = document.querySelector('footer.footer');
    if (!footer || footer.classList.contains('amft')) return;

    var blocks = footer.querySelectorAll('.footer-block');
    if (!blocks.length) return;

    var made = 0;

    Array.prototype.forEach.call(blocks, function (block, i) {
      // заглавието на блока
      var head = block.querySelector('.footer-block__heading, h2, h3, .h4');
      // има ли изобщо какво да се сгъва
      var body = block.querySelector('ul, .footer-block__details-content, .list-menu');
      if (!head || !body || !head.textContent.trim()) return;

      block.classList.add('amft-block');
      block.setAttribute('data-open', '0');

      // заглавието -> бутон, без да го местим от DOM-а
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'amft-toggle';
      btn.setAttribute('aria-expanded', 'false');
      var bodyId = body.id || ('amft-body-' + i);
      body.id = bodyId;
      btn.setAttribute('aria-controls', bodyId);
      btn.textContent = head.textContent.trim();

      head.setAttribute('hidden', '');
      block.insertBefore(btn, head);

      // всичко след заглавието се увива, за да се крие наведнъж
      var wrap = document.createElement('div');
      wrap.className = 'amft-body';
      var node = head.nextSibling;
      while (node) {
        var next = node.nextSibling;
        if (node !== btn) wrap.appendChild(node);
        node = next;
      }
      block.appendChild(wrap);

      btn.addEventListener('click', function () {
        var open = block.getAttribute('data-open') === '1';
        block.setAttribute('data-open', open ? '0' : '1');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });

      made++;
    });

    if (made) footer.classList.add('amft');
  }

  function run() {
    if (window.matchMedia && window.matchMedia(MQ).matches) init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // ако някой завърти телефона от десктоп ширина към мобилна
  if (window.matchMedia) {
    var mq = window.matchMedia(MQ);
    var onChange = function (e) { if (e.matches) init(); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }
})();
